import { ErrorBoundary } from './components/ErrorBoundary';
import { AppContent } from './components/AppContent';

export default function App() {
  return (
    <ErrorBoundary
      fallback={
        <div className="p-8">
          <div className="max-w-md">
            <h1 className="text-2xl font-bold text-red-600 mb-4">
              Something went wrong
            </h1>
            <p className="mb-6 text-gray-600">
              We're having trouble loading the application. Please try
              refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Refresh Page
            </button>
          </div>
        </div>
      }
    >
      <AppContent />
    </ErrorBoundary>
  );
}
